module.exports = __webpack_public_path__ + "img/ht.abade8e8.jpg";